import classNames from "classnames";
import { ReactNode, useState } from "react";
import { Button } from "../Button";

type Option = {
  render: string | ReactNode;
  key: string;
};

type Props = {
  options: Option[];
  active?: number;
  onChange?({ key, index }: { key: string; index: number }): void;
};

export const ToggleButton = ({ options, active = -1, onChange }: Props) => {
  const [activeIndex, setActiveIndex] = useState(active);

  return (
    <div className="toggle-buttons-group">
      {options.map((option, index) => {
        return (
          <Button
            id={`toggle-button-${option.key}`}
            key={option.key}
            className={classNames("toggle-button", {
              "toggle-button-selected": index === activeIndex,
            })}
            spacing="tight-hug"
            fill="outline"
            disabled={index === activeIndex}
            onClick={() => {
              setActiveIndex(index);
              onChange?.({ key: option.key, index });
            }}
          >
            {option.render}
          </Button>
        );
      })}
    </div>
  );
};

export default {};
